<template>
  <crud-modal
    title="Firmen für Abacus exportieren"
    action="export"
    :on-submit="submit"
    :on-close="() => $emit('close')"
  >
    <div class="flex flex-wrap w-full">
      <span>Durch angabe eines Monat können nur die Daten exportiert werden, welche sich in dem Monat geändert haben</span>
      <div class="w-full px-4 mb-3">
        <input-date-validated
          ref="month"
          v-model="month"
          label="Monat"
          type="month"
        />
      </div>
    </div>
  </crud-modal>
</template>
<script>
import CrudModal from '@/components/modals/crud-modal'
import InputDateValidated from '@/components/form/date-validated'

import { exportAbacusCompany } from '@/lib/export'

export default {
  components: { CrudModal, InputDateValidated },
  data () {
    return {
      month: null
    }
  },
  methods: {
    async submit () {
      const monthParam = this.month && this.month.toISOString().slice(0, 7)
      await exportAbacusCompany(monthParam)
    }
  }
}
</script>
